export const typesList = [
  {
    value: "string",
    name: "String",
  },
  {
    value: "boolean",
    name: "Boolean",
  },
  {
    value: "number",
    name: "Number",
  },
  {
    value: "object",
    name: "Parent",
  },
];

export const fieldModel = (id) => ({
  id,
  name: {
    value: `field_0`,
    error: false,
  },
  type: {
    value: "string",
    error: false,
  },
  value: {
    value: "value",
    error: false,
  },
});
